import { jwtDecode } from "jwt-decode";

type AgelessAssessmentJwtPayload = {
  ageless_assessment_id?: string;
};

export function getAssessmentIdFromBearerToken(authorizationHeader: string): string | undefined {
  const token = authorizationHeader.replace(/^Bearer\s+/i, "").trim();
  if (!token) {
    return undefined;
  }

  try {
    const decoded = jwtDecode<AgelessAssessmentJwtPayload>(token);
    return decoded.ageless_assessment_id;
  } catch {
    return undefined;
  }
}
